import Select from 'react-select';

type Props = {
    className?: any,
    onChange: Function,
    placeHolder?: any,
    value: any,
    isMulti?: boolean,
    options: any,
    name?: any,
    disabled?: boolean,
    id?:any
};
function WMSSelect(props: Props){
    let { className, isMulti, placeHolder, options, id,value, onChange,name,disabled, ...restProps } = props;
    return(
        <>
            <Select
                isDisabled={disabled}
                value={value}
                onChange={(e :any) => props.onChange(e)}
                options={options}
                isMulti={isMulti}
                name={name}
                placeholder={placeHolder}
                id={id}
                classNamePrefix="custom-select"
            />
        </>
    )
}
export {
    WMSSelect
};
